import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import {
  useGetBillingAddressDataQuery,
  useGetShippingAddressDataQuery,
} from "../../../services/myAccountAPI";
import Loader from "../fullPageLoader";

function Address() {
  // Fetch order data for the current user and page
  const {
    data,
    error,
    isLoading,
    refetch: refetchBilling,
  } = useGetBillingAddressDataQuery();
  const {
    data: shippingData,
    error: shippingError,
    isLoading: shippingIsLoading,
    refetch: refetchShipping,
  } = useGetShippingAddressDataQuery();

  useEffect(() => {
    refetchBilling();
    refetchShipping();
  }, [refetchBilling, refetchShipping]);

  if (isLoading || shippingIsLoading) return <Loader />;
  if (error || shippingError) return <p>Failed to load data page content</p>;

  // Extract orders and pagination data from the API response
  const billingAddress = data?.data || [];

  const shippingAddress = shippingData?.data || [];

  const userId = localStorage.getItem("gridMarker");

  return (
    <div className="address-page">
      <div>
        <h5 className="mb-4">
          The following addresses will be used on the checkout page by default.
        </h5>
        <div className="row">
          <div className="col-md-6 col-lg-6 col-sm-12">
            <h4>Billing address</h4>
            {billingAddress.length > 0 ? (
              <Link to={`/edit-billing-address/${billingAddress[0].user_id}`}>
                <p>
                  <FontAwesomeIcon icon={faEdit} /> Edit Billing address
                </p>
              </Link>
            ) : (
              <div>
                <Link to={`/add-billing-address/${userId}`}>
                  <p>
                    <FontAwesomeIcon icon={faEdit} /> Add Billing address
                  </p>
                </Link>

                <h5>
                  <i>You have not set up this type of address yet.</i>
                </h5>
              </div>
            )}
          </div>

          <div className="col-md-6 col-lg-6 col-sm-12">
            <h4>Shipping address</h4>
            {shippingAddress.length > 0 ? (
              <Link to={`/edit-shipping-address/${shippingAddress[0].user_id}`}>
                <p>
                  <FontAwesomeIcon icon={faEdit} /> Edit Shipping address
                </p>
              </Link>
            ) : (
              <div>
                <Link to={`/add-shipping-address/${userId}`}>
                  <p>
                    <FontAwesomeIcon icon={faEdit} /> Add Shipping address
                  </p>
                </Link>

                <h5>
                  <i>You have not set up this type of address yet.</i>
                </h5>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Address;
